import { guitarSetups, selectNpsValues } from "./chartOptions";

// Shared by the Designer slice and the trainers' small configuration contexts.
// Keeping these handlers together preserves the existing preset/action rules.
export const musicalConfigurationReducers = {
  setGuitarSetup(state, action) {
    const value = action.payload;
    if (value in guitarSetups) {
      state.guitarSetup = value;
      if (value === "custom") return;
      state.tuning = guitarSetups[value][1];
      state.midiRootNote = guitarSetups[value][0];
    }
  },
  setCustomTuning(state, action) {
    if (state.guitarSetup === "custom") state.tuning = action.payload;
  },
  setMidiRootNote(state, action) {
    if (state.guitarSetup === "custom") state.midiRootNote = +action.payload;
  },
  setSelectNps(state, action) {
    if (selectNpsValues.includes(action.payload)) state.selectNps = action.payload;
  },
  setInterval(state, action) {
    state.intervals[action.payload.index] = action.payload.value;
  },
  setAllIntervals(state, action) {
    state.intervals = action.payload;
  },
  setIntervalColor(state, action) {
    state.intervalColors[action.payload.index] = action.payload.color;
  },
  setAllIntervalColors(state, action) {
    state.intervalColors = action.payload;
  },
};

export function copyMusicalConfiguration(state) {
  return {
    guitarSetup: state.guitarSetup,
    tuning: [...state.tuning],
    midiRootNote: state.midiRootNote,
    intervals: [...state.intervals],
    intervalColors: [...state.intervalColors],
    selectNps: state.selectNps,
  };
}
